// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nLWQ","index":"styles_index__sg3GO"};